import { render, staticRenderFns } from "./settlementMsg.vue?vue&type=template&id=c03d9286&scoped=true"
import script from "./settlementMsg.vue?vue&type=script&lang=js"
export * from "./settlementMsg.vue?vue&type=script&lang=js"
import style0 from "./settlementMsg.vue?vue&type=style&index=0&id=c03d9286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03d9286",
  null
  
)

export default component.exports